import { BaseClass } from 'digicon-events-base';
import { i18n } from 'digicon-web-localization/localization';
import feedBack from 'digicon-web-feedback/feedBack';
import moment from 'moment';
import { Toastr } from 'digicon-web-feedback/utils/toastr/toastr';

export class Projects extends BaseClass {
    constructor(properties) {
        super();
        this.modules = properties.modules;
        this.toastr = new Toastr();
    }

    _initProjectsStructure() {
        document.querySelector('.aside').style.display = "none";
        document.querySelector('.container-xxl').classList.remove("with-aside");
        document.querySelector('.wrapper').classList.add('px-0');
        document.querySelectorAll(`#progressbar li`).forEach((element) => {
            element.remove();
        });
        document.querySelector('#steps').style.display = "none";
        document.querySelector('#content').style.marginTop = "0px";
        document.querySelector('.container-xxl > div.title').insertAdjacentHTML(
            'beforeend',
            `<button type="button" class="btn primary createProject">${i18n('create')} <i class="fa-solid fa-plus"></i></button>`
        );
        document.querySelector('.container-xxl > div.title').style.justifyContent = "flex-start";
        document.querySelector('.content').style.padding = "30px 0px";
        document.querySelector('.project-body').style.display = "none";
        document.querySelector('.container-xxl .card-body').classList.add('card-body-projects');
        document.querySelector(`.createProject`).addEventListener('click', async (event) => {
            await this._createNewProject();
        }, this);
    }

    async _fillProjectsContainer() {
        await this._getProjects();
        document.querySelectorAll('#projectsTable tr .btn-delete').forEach(item => {
            item.addEventListener('click', async (event) => {
                const formButtons = [
                    {
                        label: i18n('nameMenuAcceptText'),
                        classList: ['primary'],
                        action: async () => {
                            document.getElementById('splash').dataset.visible = true;
                            let id = 0;
                            if (event.target.localName === 'i') {
                                id = event.target.parentElement.getAttribute('id').split("-")[2];
                            } else {
                                id = event.target.getAttribute('id').split("-")[2];
                            }
                            const bodyData = `{
                                "username": "${sessionStorage.lcoe_loginhash}",
                                "id": "${id}"
                            }`;
                            let rawResponse = await fetch(`${location.href}webresources/lcoeF3/deleteProject`, {
                                method: 'delete',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: bodyData
                            });
                            const result = await rawResponse.json();
                            if (result.status === 200) {
                                feedBack.closeFeedBack();
                                document.getElementById('splash').dataset.visible = false;
                                this.toastr.success(i18n("deleted"), "");
                                await this._getProjects();
                            } else {
                                feedBack.closeFeedBack();
                                document.getElementById('splash').dataset.visible = false;
                                this.toastr.error(i18n("failedToDelete"), "");
                            }
                        }
                    },
                    {
                        label: i18n('nameMenuCancelText'),
                        classList: ['default'],
                        action: () => {
                            feedBack.closeFeedBack();
                        }
                    }];
                let htmlObj = '<div class="feedBackContent"><div class="error-image"></div></div>';
                htmlObj += `<div class="error-text">${i18n('areYouSure')}</div>`;
                feedBack.openHtmlDialog(htmlObj, formButtons);
            });
        });
    }

    async _getProjects() {
        let rawProjectsResponse = await fetch(`${location.href}webresources/lcoeF3/getUserProjects?` + new URLSearchParams({
            username: sessionStorage.lcoe_loginhash
        }), {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const projectsResult = await rawProjectsResponse.json();
        let body = ``;
        if (projectsResult.status === 200) {
            projectsResult.data.sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime());
            projectsResult.data.forEach(function (element) {
                body +=
                    `<tr>
                        <td><button class="btn btn-select" id="project-${element.id}">Select</button></td>
                        <td class='align-middle'>${element.name}</td>
                        <td class='align-middle'>${element.type}</td>
                        <td class='align-middle'>${moment(element.created).format('DD-MM-YYYY HH:mm:ss')}</td>
                        <td class="text-end"><button class="btn btn-danger btn-delete" id="project-delete-${element.id}"><i class="fa-solid fa-trash"></i></button></td>
                    </tr>`;
            });
        }
        const table =
            `<table id="projectsTable" class="table table-striped">
                <thead>
                    <tr>
                        <th></th>
                        <th>${i18n('name')}</th>
                        <th>${i18n('type')}</th>
                        <th>${i18n('creation')}</th>
                        <th class="text-end">${i18n('options')}</th>
                    </tr>
                </thead>
                <tbody>
                    ${body}
                </tbody>
            </table>`;
        document.querySelector('.container-xxl h2').innerText = `${i18n('projects')}`;
        document.querySelector('.container-xxl .card-body #content').innerHTML =
            `<div id="projectContainer" class="projectContainer">
                ${table}
            </div>`;
        document.querySelectorAll('#projectsTable tr .btn-select').forEach(item => {
            item.addEventListener('click', async (event) => {
                this.trigger('onUserSelectProject', event.target.getAttribute('id').split("-")[1]);
            });
        });
    }

    async _createNewProject() {
        let rawProjectsResponse = await fetch(`${location.href}webresources/lcoeF3/getUserProjectTypes?` + new URLSearchParams({
            username: sessionStorage.lcoe_loginhash
        }), {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const resultProjectTypes = await rawProjectsResponse.json();
        if (resultProjectTypes.status === 200) {
            const formButtons = [
                {
                    label: i18n('nameMenuCreateText'),
                    classList: ['primary'],
                    action: async () => {
                        const projectNameValue = document.getElementById('newProjectName').value;
                        const projectTypeValue = document.getElementById('newProjectType').value;
                        if (projectNameValue === '') {
                            document.querySelector(`#newProjectName`).style.border = "solid 1px #ff0000";
                        }
                        else {
                            document.getElementById('splash').dataset.visible = true;
                            document.querySelector(`#newProjectName`).style.border = "solid 1px #5E6278";
                            let projectType = 0;
                            let data = {
                                username: sessionStorage.lcoe_loginhash,
                                name: projectNameValue,
                                type: projectTypeValue
                            };
                            let rawCreateProjectResponse = await fetch(`${location.href}webresources/lcoeF3/createProject?`, {
                                method: 'put',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(data)
                            });
                            const result = await rawCreateProjectResponse.json();
                            if (result.status === 200) {
                                feedBack.closeFeedBack();
                                document.getElementById('splash').dataset.visible = false;
                                this.toastr.success(i18n("created"), "");
                                this.trigger('onUserSelectProject', result.data.id);
                            } else {
                                feedBack.closeFeedBack();
                                document.getElementById('splash').dataset.visible = false;
                                self.toastr.error(i18n("notCreated"), "");
                            }
                        }
                    }
                },
                {
                    label: i18n('nameMenuCancelText'),
                    classList: ['default'],
                    action: () => {
                        feedBack.closeFeedBack();
                    }
                }];
            let projectTypeBody = '';
            for (let i = 0; i < resultProjectTypes.data.length; i++) {
                projectTypeBody += `<option value="${resultProjectTypes.data[i].id}">${resultProjectTypes.data[i].name}</option>`;
            }

            let htmlObj = '<div class="feedBackContent"><div class="create"></div></div>';
            htmlObj += `<form id="createProjectForm">
                <div id="createProjectForm-container">
                    <h2 id="createProjectForm-title">${i18n('newProject')}</h2>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label for="newProjectName" class="formLabel">${i18n('name')}</label>
                                <input type="text" class="form-control" id="newProjectName" name="newProjectName" required>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label for="newProjectType" class="formLabel">${i18n('type')}</label>
                                <select id="newProjectType" class="form-select" name="newProjectType">${projectTypeBody}</select>
                            </div>
                        </div>
                    </div>
                </div>
            </form>`;
            feedBack.openHtmlDialog(htmlObj, formButtons);
        }
    }
}